import { render, staticRenderFns } from "./VodDisclaimer.vue?vue&type=template&id=1f636790&scoped=true&"
import script from "./VodDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./VodDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./VodDisclaimer.vue?vue&type=style&index=0&id=1f636790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f636790",
  null
  
)

export default component.exports